document.addEventListener("alpine:init", () => {
  Alpine.data("paymentPlans", (settings = {}) => ({
    activeItem: 0,
    source: {},
    init() {
      this.activeItem = settings.activeItem || 0;
      this.source = settings.source || {};
    },
    render() {
      return `
        <template x-for="plan in source">
          <div class="p-2 border border-slate-400">
            <div x-data="paymentPlanLine({ plan: plan })" x-html="render($el)">
          </div>
        </template>
      `;
    },
    message() {
      this.$refs.tagName.innerText = "Hello World";
    },
  }));
});

document.addEventListener("alpine:init", () => {
  Alpine.data("paymentPlanLine", (settings = {}) => ({
    activeItem: 0,
    init() {
      this.activeItem = settings.activeItem || 0;
    },
    render() {
      return `
      <sl-input type="text" label="Plan Name" x-model="plan.post_title"></sl-input>
      <span x-text="$data.source.length"></span>
      `;
    },
  }));
});
